<template>
	<van-popup v-model="show" :position="isMobileFlag?'bottom':'center'" get-container="body" closeable
		class="bs-popup">
		<div class="bs-popup-head">
			<div class="bs-popup-tit">
				{{$t('设置支付密码')}}
			</div>
		</div>
		<div class="bs-popup-scroll">
			<div class="bs-popup-body">
				<el-form ref="form" :model="form">
					<el-form-item v-if="this.$helper.get('userInfo').paypwd != ''">
						<el-input type="tel" maxlength="6" v-model="form.old_pay_pwd"  @input="filterInput('old_pay_pwd')" :placeholder="$t('请输入原密码')"></el-input>
					</el-form-item>
					<el-form-item >
						<el-input type="tel" maxlength="6" v-model="form.new_pay_pwd"  @input="filterInput('new_pay_pwd')" :placeholder="$t('请设置6位数支付密码')"></el-input>
					</el-form-item>
					<el-form-item >
						<el-input type="tel" maxlength="6" v-model="form.confirm_pay_pwd"  @input="filterInput('confirm_pay_pwd')" :placeholder="$t('请确认支付密码')"></el-input>
					</el-form-item>
					<el-row :gutter="20" class="btn-foot-row">
						<el-col :span="12">
							<el-button round @click="show = false"  type="warning">{{$t('取消')}}</el-button>
						</el-col>
						<el-col :span="12">
							<el-button round type="primary" @click="onSubmit">{{$t('确定')}}</el-button>
						</el-col>
					</el-row>	
				</el-form>
			</div>
		</div>
	</van-popup>

</template>

<script>
	import {set_pay_pwd_api} from "@/api/user"
	export default {
		components: {},
		data() {
			return {
				show: false,
				paypwd:'',
				form: {
					old_pay_pwd: '',
					new_pay_pwd: '',
					confirm_pay_pwd: '',
				}
			};
			
		},
		methods: {
		filterInput(field) {
		      // Use a regular expression to remove non-numeric characters
		      this.form[field] = this.form[field].replace(/\D/g, '').slice(0, 6);
		    },
		  async onSubmit() {
		    try {
		      if (this.form.old_pay_pwd == "" && this.$helper.get('userInfo').paypwd != "") {
		        this.errorTips(this.$t("请输入原密码"));
		        return false;
		      }
		      if (this.form.new_pay_pwd == "") {
		        this.errorTips(this.$t("请设置6位数支付密码"));
		        return false;
		      }
		      if (this.form.confirm_pay_pwd == "") {
		        this.errorTips(this.$t("请确认支付密码"));
		        return false;
		      }
			  
		      let param = {
		        old_pay_pwd: this.form.old_pay_pwd,
		        new_pay_pwd: this.form.new_pay_pwd,
		        confirm_pay_pwd: this.form.confirm_pay_pwd,
		      };
		      
		      const loading = this.$loading({
		        lock: true,
		        text: '',
		        spinner: 'loader',
		        background: 'rgba(255, 255, 255, 0.3)'
		      });
		      
		      const res = await set_pay_pwd_api(param);
		      
		      loading.close();
		      
		      if (res && res.data && res.data.code == 1) {
		        this.successTips(res.data.msg);
				this.updateUserInfo()
		        this.show = false;
				location.reload()
				this.$emit('reload');
		      } else {
		        this.errorTips(res.data.msg);
		      }
		    } catch (error) {
		      console.log('修改密码时出错:', error);
		    }
		  }
		},

		mounted() {
			
		}
	}
</script>
<style scoped>
	.btn-foot-row{
		padding: 10px 0;
	}
	.btn-foot-row .el-button{
		width: 100%;
	}

<style scoped>
	.btn-foot-row{
		padding: 10px 0;
	}
	.btn-foot-row .el-button{
		width: 100%;
	}
</style>